import React from "react";
import ContentLoader from "react-content-loader";

const Skeleton = ({ props, children }) => (
  <ContentLoader
    speed={props?.speed || 2}
    width={props?.width || "100%"}
    height={props?.height || "100%"}
    viewBox={`0 0 ${props?.viewBox}`}
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    {children}
  </ContentLoader>
);

export default Skeleton;
